var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.987 7.255a.437.437 0 0 1 .388-.234h5.25a.437.437 0 0 1 .36.687L4.36 11.499a.437.437 0 0 1-.72 0L1.015 7.708a.438.438 0 0 1-.028-.453Zm1.223.641L4 10.482l1.79-2.586H2.21ZM4 .313c.144 0 .278.07.36.188l2.625 3.792a.437.437 0 0 1-.36.686h-5.25a.437.437 0 0 1-.36-.686L3.64.5A.437.437 0 0 1 4 .312ZM2.21 4.104h3.58L4 1.52 2.21 4.104Z",
  fill: "#fff"
})));
export default SvgSortSvg;